
import { customElement, property } from 'lit/decorators.js';
import { LitElement, html } from 'lit';

import style from './usos-tag.scss'

/**
 * Component showing short content with coloured background
 *
 * @slot - content
 */
@customElement('usos-tag')
export class UsosTag extends LitElement {
    static override styles = style;

    /**
     * Color of tag.
     */
    @property({reflect: true}) color: '1' | '2' | '3' | '4' | '5' | '6' = '1';

    /**
     * Should use slim variant?
     */
    @property({reflect: true, type: Boolean}) slim = false;

    /**
     * Should preserve text case?
     */
    @property({reflect: true, type: Boolean, attribute: 'preserve-case'}) preserveCase = false;

    override render() {
        return html`
            <slot></slot>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
      "usos-tag": UsosTag,
    }
}
